/** Strip synthetic ponctuel prefix from stored client company names. */
const PONCTUEL_COMPANY_PREFIX_RE = /^Ponctuel\s*[—\-–]\s*/i;

/** Auto-created client transporteur names end with " — Transport". */
const AUTO_TRANSPORT_SUFFIX_RE = /\s*[—\-–]\s*Transport\s*$/i;

/**
 * Primary label for the load's billing client (loads table, modals).
 * Prefer load.client when linked; never show carrier name instead of client.
 */
export function getLoadClientDisplayName(load) {
  if (!load) return '';

  const client = load.client;
  if (client?.companyName) {
    let name = String(client.companyName).trim();
    if (String(client.billingType || '').toUpperCase() === 'PONCTUEL') {
      const stripped = name.replace(PONCTUEL_COMPANY_PREFIX_RE, '').trim();
      if (stripped) name = stripped;
    }
    return name;
  }

  if (load.clientId) {
    return '';
  }

  const carrier = String(load.transporteur?.companyName || '').trim();
  if (!carrier) return '';
  const withoutSuffix = carrier.replace(AUTO_TRANSPORT_SUFFIX_RE, '').trim();
  return withoutSuffix || carrier;
}

/** Secondary line (contact) under client name in tables. */
export function getLoadClientContactName(load) {
  if (!load) return '';
  if (load.client?.contactName) {
    return String(load.client.contactName).trim();
  }
  if (!load.clientId && load.transporteur?.contactName) {
    return String(load.transporteur.contactName).trim();
  }
  return '';
}
